export function currentUserHasMembership(currentUser) {
  const metadata = currentUser?.attributes?.profile?.metadata;
  return Boolean(metadata?.membership);
}
